import React from 'react';
import {Text, View} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import {styles} from './styles';
import {Button} from '@components/atoms';

export const Payment = ({onPressPayment, onPressRules, isFetching, disabled, style, isMobile}) => {
    const navigation = useNavigation();
    return (
        <View style={style}>
            <Button
                customStyles={[styles.btn, {width: isMobile ? '100%' : '60%'}]}
                isFetching={isFetching}
                onPress={onPressPayment}
                disabled={disabled}
            >
                <View style={styles.btnContent}>
                    <Text style={styles.btnText}>Оплатить 300₽</Text>
                    {/*<YookassaIcon/>*/}

                </View>
            </Button>
            <>
                <Text style={styles.terms}>
                    Совершая оплату вы соглашаетесь с{' '}
                    <Text
                        style={styles.termsLink}
                        onPress={onPressRules}
                    >
                        условиями
                    </Text>
                </Text>
            </>
        </View>
    );
};
